module.exports = __webpack_public_path__ + "static/media/saba-sport.19fa7c7f.webp";